module.exports = __webpack_public_path__ + "static/img/login_logo3.d0729abc.png";